import { useEffect, useState } from "react";
import axios from "axios";
import { Estate, Unit } from "../../types/estate";
import "./portfolio.scss";
import { Link } from "react-router-dom";
import { gsap } from "gsap-trial";
import { m } from "framer-motion";

const Portfolio = () => {
    const [estates, setEstates] = useState<Estate[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        gsap.fromTo(
            ".portfolio-one",
            { opacity: 0 },
            { opacity: 1, duration: 1, ease: "power2.out" }
        );
        const fetchPosts = async () => {
            try {
                const response = await axios.get(
                    "https://wp.sirendigital.uk/space-industrial/wp-json/wp/v2/posts?_embed"
                );
                setEstates(response.data);
            } catch (err) {
                setError("Failed to load posts");
            } finally {
                setLoading(false);
            }
        };
        fetchPosts();
    }, []);



    useEffect(() => {
        const timeline = gsap.timeline({});
        timeline

            .fromTo(
                ".portfolio",
                { clipPath: "polygon(0 0, 0 0, 0 100%, 0 100%)" },
                {
                    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                    duration: 1,
                    stagger: 0.25,
                    ease: "power2.out",
                }
            )
            .fromTo(
                ".portfolio:nth-child(3n)",
                { clipPath: "polygon(0 0, 0 0, 0 100%, 0 100%)" },
                {
                    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                    duration: 1,
                    ease: "power2.out",
                },
                "<"
            );
    }, [estates]);

    return (
        <>
            <div className="contain-wrapper">
                <div className="portfolio-one contain">
                    <p>
                        Home / <span className="volt">Portfolio</span>
                    </p>
                    <h1>Space for your business</h1>
                </div>
            </div>
            <div className="contain-wrapper">
                <div className="portfolio-two contain">
                    {estates &&
                        estates.map((estate, index) => {
                            return (
                                <Link
                                    target="_top"
                                    className="portfolio"
                                    to={`/portfolio/${estate.slug}`}
                                >
                                    <div
                                        style={{
                                            backgroundImage:
                                                estate._embedded &&
                                                estate._embedded[
                                                    "wp:featuredmedia"
                                                ]
                                                    ? `url(${estate._embedded["wp:featuredmedia"][0].source_url})`
                                                    : "none",
                                            backgroundColor:
                                                estate._embedded &&
                                                estate._embedded[
                                                    "wp:featuredmedia"
                                                ]
                                                    ? "transparent"
                                                    : "black",
                                        }}
                                        className="estate"
                                        key={index}
                                    >
                                        <div className="overlay">
                                            <div className="wrapper">
                                                <div className="logo-wrapper">
                                                    <img
                                                        src="../ui/logo.svg"
                                                        alt="logo"
                                                        className="logo"
                                                    />
                                                    <h3>{estate.acf.name}</h3>
                                                </div>
                                            </div>

                                            <div className="wrapper">                                                
                                                <h4>{estate.acf.postcode}</h4>
                                                <h4 className="volt">/</h4>
                                                <h4>{estate.acf.sq_ft}</h4>
                                                <h4 className="volt">/</h4>
                                                {estate.acf.sq_ft_available ? (<><h4>{estate.acf.sq_ft_available} available</h4></>): <h4>Fully Let</h4> }
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            );
                        })}
                </div>
            </div>
        </>
    );
};

export default Portfolio;
